import { ApiRequest } from './apiclient.js';

export class BillingClient
{
    constructor ()
    {
        this.state = null;
        this.payment = null;
        this.orders = [];
    }

    async GetState ()
    {
        let result = await ApiRequest ('GET', '/billing');
        this.state = result.billing;
        // Whether a card can be charged at all. Nothing in the interface may
        // offer paying by card while this says it cannot.
        this.payment = result.payment;
        this.orders = result.orders;
        return this.state;
    }

    // Not a payment method: it decides whether the next invoice is created
    // without being asked for. Nothing is charged either way.
    async SetAutoRenew (enabled)
    {
        let result = await ApiRequest ('POST', '/billing/autorenew', { enabled : enabled });
        this.state = result.billing;
        return this.state;
    }

    async RequestInvoice (plan, period, company)
    {
        let result = await ApiRequest ('POST', '/billing/request', {
            plan : plan,
            period : period,
            company : company
        });
        this.state = result.billing;
        return result.order;
    }
}
